/**
 * The build credit. Deliberately a constant and not a setting: it is an attribution, not branding an
 * administrator configures, and putting it in Settings would invite it being edited or blanked.
 *
 * The copyright line beside it IS configurable - that one belongs to the customer.
 */
export const DEVELOPER_CREDIT = 'Design and Developed by Cloudzent';

/** Opened in a new tab: the two places this appears are a sidebar and a sign-in screen, and
 *  navigating away from either loses whatever the user was in the middle of. */
export const DEVELOPER_URL = 'https://www.cloudzent.com/';
